import { Button, colors, Modal } from '@insurancemenu/imenu-components-lib';
import { NotificationImportant } from '@insurancemenu/imenu-components-lib/dist/icons';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useChooseTheWayPageStore } from 'store/pages/proposal-generation/chooseTheWayPageStore';
import { FooterStyled, MessageStyled, ModalBodyStyled, TitleStyled } from './styles';
import {
  OUTDATED_FILES_MODAL_BUTTON_TEST_ID,
  OUTDATED_FILES_MODAL_MESSAGE_TEST_ID,
  OUTDATED_FILES_MODAL_TEST_ID,
  OUTDATED_FILES_MODAL_TITLE_TEST_ID,
} from '../constants';

const OutdatedFilesModal: React.FC = observer(() => {
  const { areFilesOutdated } = useChooseTheWayPageStore();

  const [showModal, setShowModal] = useState(false);

  function onClose(): void {
    setShowModal(false);
  }

  useEffect(() => {
    if (areFilesOutdated) {
      setShowModal(true);
    }
  }, [areFilesOutdated]);

  return (
    <Modal show={showModal} onClose={onClose} width="51rem" data-test-id={OUTDATED_FILES_MODAL_TEST_ID}>
      <ModalBodyStyled>
        <NotificationImportant width="9rem" color={colors.orange[600]} />
        <TitleStyled data-test-id={OUTDATED_FILES_MODAL_TITLE_TEST_ID}>Uploaded files outdated!</TitleStyled>
        <MessageStyled data-test-id={OUTDATED_FILES_MODAL_MESSAGE_TEST_ID}>
          The data that had been uploaded previously is outdated. You need to submit the new data to form a new file.
        </MessageStyled>
        <FooterStyled>
          <Button onClick={onClose} size="large" type="outlined" data-test-id={OUTDATED_FILES_MODAL_BUTTON_TEST_ID}>
            Okay
          </Button>
        </FooterStyled>
      </ModalBodyStyled>
    </Modal>
  );
});

export default OutdatedFilesModal;
